import { cn } from '@/lib/utils';

interface BchLogoProps {
  className?: string;
}

/** BCH Signature logo: a "B" whose stem is an upright fountain pen. */
export function BchLogo({ className }: BchLogoProps) {
  return (
    <img
      src="/logo.png"
      alt="BCH Signature"
      className={cn('object-contain', className)}
    />
  );
}
